<template>
    <div
        :class="stack ? '' : 'h-100'"
        class="widget d-flex flex-column justify-content-start align-items-start px-1 px-md-3 py-1 py-md-2 m-1"
    >
        <h6 class="mb-0 text-uppercase">Total rates</h6>
        <small class="text-muted mb-0"
            ><em>current length: {{ moment(goal.created_at).fromNow(true) }}</em></small
        >
        <hr
            style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
        />
        <div class="mb-2 w-100">
            <div
                v-for="target in goal.parameters.targets"
                class="w-100 d-flex justify-content-between align-items-center"
            >
                <small class="text-nowrap text-capitalize mr-3">{{ target }}:</small>
                <small class="text-nowrap">{{ getTargetRate(target) }}</small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProgressMultiTally",
    props: ["goal", "trackers", "stack"],
    computed: {
        totalTime() {
            return this.trackers.reduce((agg, cur) => agg + cur.data.time, 0);
        },
    },
    methods: {
        getTargetRate(target) {
            const totalTargetTally = this.trackers.reduce(
                (agg, cur) => agg + _.get(cur, `data.results.${target}`, 0),
                0
            );
            return this.totalTime
                ? Math.round((100 * totalTargetTally) / (this.totalTime / 60)) / 100 + "/min."
                : "N/A";
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
}
</style>
